import * as React from 'react';
import { collection, addDoc } from "firebase/firestore";
import { db } from '../../firebase_services';
import Typography from '../components/Typography';
import TextField from '../components/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { createTheme } from '@mui/material/styles';
import logo from '../images/caavlogo.png';

const backgroundImage = 'https://images.unsplash.com/photo-1534854638093-bada1813ca19?auto=format&fit=crop&w=1400';

const heroVideo = 'https://caav.mx/static/media/video_1.0c9fdb226c180d0fb7e8.m4v'
/* 'https://firebasestorage.googleapis.com/v0/b/festival-caav.appspot.com/o/videos%2FbackgroundVideo.mp4?alt=media&token=bebdc452-9cac-4ebb-9f5e-a412036b9546' */

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default function ProductHero() {
  const [terms, setTerms] = React.useState(false)
  const [showTerms, setShowTerms] = React.useState(false)
  const [name, setName] = React.useState("")
  const [email, setEmail] = React.useState("")

  const sendInfo = async () => {
    if(name != "" && email != ""){
      try{
        const data = {
          name: name,
          email: email
        }
        const colRef = collection(db, "users")
        const docSnap = await addDoc(colRef, data)
        if(docSnap.id){
          setTerms(false)
          setName("")
          setEmail("")
        }
      }catch(error){
        console.log("add doc error: ", error)
      }
    }
  }

  return (
    <Container sx={{
      mt: 0,
      mb: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <Box
        sx={{
          position: 'fixed',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          backgroundColor: 'common.black',
          opacity: 0.6,
          zIndex: -1,
          width: "100%", height: "100%"
        }}
      />
      <video 
        className='videoTag' 
        autoPlay 
        loop 
        muted
        style={{ position: "fixed", width: "100%", height: "100%", backgroundSize: 'cover', objectFit: "cover", zIndex: -2, bottom: -10 }}
      >
        <source 
          src={heroVideo} type='video/mp4' 
        />
      </video>
      <Grid align="center" sx={{ 
          display: "flex", 
          marginTop: "32px",
          [theme.breakpoints.down('sm')]: {
            flexDirection: "column", 
          },
          [theme.breakpoints.up('sm')]: {
            flexDirection: "row", 
          }  
        }}
      >
        <Typography color="inherit" align="center" variant="h1" sx={{fontFamily: "Kaushan Script", color: "white"}}>
          Festival
        </Typography>
        <img
          src={logo}
          alt="logo"
          width="200"
          height="66"
          style={{ marginBottom: "32px", marginLeft: "16px", marginTop: "12px" }}
        />
      </Grid>
      <Typography color="inherit" align="center" variant="h5" sx={{color: "white"}}>
        1era Edición
      </Typography>
      <Typography color="inherit" align="center" variant="h2" sx={{color: "white"}}>
        2023
      </Typography>
      <Typography color="inherit" align="center" variant="subtitle1" sx={{color: "white"}}>
        Revisa todas nuestras convocatorias {" "}
        <Link href="/calls" rel="noreferrer" target="_blank" color="inherit" variant="subtitle1">aquí</Link>.
      </Typography>
      <Typography
        color="inherit"
        align="center"
        variant="h4"
        sx={{ mt: { xs: 4, sm: 4 }, fontFamily: "Kaushan Script", color: "white"}}
      >
        ¡Únete a nosotros!
      </Typography>
      <Typography
        color="inherit"
        align="center"
        variant="h5"
        sx={{ mb: 4, mt: 1, color: "white" }}
      >
        Regístrate al boletín semanal para recibir novedades especiales y más.
      </Typography>
      <Grid align="center">
        <TextField
          noBorder
          placeholder="Nombre"
          variant="standard"
          sx={{ width: 300, mb: 2, mr: 2, ml: 2 }}
          value={name}
          onChange={(event)=>{setName(event.target.value)}}
        />
        <TextField
          noBorder
          placeholder="Correo electrónico"
          variant="standard"
          sx={{ width: 300, mb: 2, mr: 2, ml: 2 }}
          value={email}
          onChange={(event)=>{setEmail(event.target.value)}}
        />
      </Grid>
      <Grid sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Checkbox size="medium" checked={terms} onChange={()=>{setTerms(!terms)}} sx={{color: "white"}}/>
        <Typography variant="subtitle1" sx={{color: "white"}}>
          Acepto el {" "}
          <Link href="/privacy" rel="noreferrer" target="_blank" color="inherit" variant="subtitle1">aviso de privacidad</Link>.
        </Typography>
      </Grid>
      <Typography variant="subtitle1" sx={{color: "white"}}>
      </Typography>
      <Button
        color="primary"
        variant="contained"
        size="large"
        component="a"
        onClick={sendInfo}
        disabled={!terms || name == "" || email == ""}
        sx={{ width: 300, height: 56, borderRadius: 2, mt: 2, mb: 2 }}
      >
        Enviar
      </Button>
    </Container>
  );
}